import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-seafoam/30 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-teal text-3xl" />
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">404</h1>
      <p className="text-navy/70 text-lg md:text-xl mb-8 max-w-md">
        This page could not be found. Let us help you get back on track.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center bg-teal text-white font-semibold px-8 py-3.5 rounded-lg hover:bg-navy transition-all duration-300 text-base whitespace-nowrap"
      >
        Back to Home
      </Link>
    </div>
  );
}